(() => {
  const setupProduct = () => {
    const main = document.querySelector('main[data-template="product"]');
    if (!main) return;

    const title = main.querySelector('h1');
    if (title && !title.previousElementSibling?.classList.contains('milaja-product-eyebrow')) {
      const eyebrow = document.createElement('p');
      eyebrow.className = 'milaja-product-eyebrow';
      eyebrow.textContent = 'MILAJA • FORM 01';
      title.before(eyebrow);
    }

    main.querySelectorAll('.add-to-cart-button').forEach((button) => {
      const text = button.textContent.trim().toLowerCase();
      const isUnavailable = text.includes('slutsåld') || text.includes('sold out');
      if (!isUnavailable || button.dataset.milajaInterestScroll === 'true') return;

      button.dataset.milajaInterestScroll = 'true';
      button.disabled = false;
      button.removeAttribute('disabled');
      button.removeAttribute('on:click');
      button.type = 'button';
      button.name = '';
      button.setAttribute('aria-controls', 'milaja-interest');
      button.innerHTML = '<span>MEDDELA MIG VID LANSERING</span>';
    });
  };

  const localize = () => {
    document.querySelectorAll('[aria-label="Available colours"]').forEach((group) => {
      group.setAttribute('aria-label', 'Tillgängliga färger');
    });

    document.querySelectorAll('main[data-template="collection"] .product-badges__badge').forEach((badge) => {
      if (['slutsåld', 'sold out'].includes(badge.textContent.trim().toLowerCase())) {
        badge.textContent = 'Kommer snart';
      }
    });

    document.querySelectorAll('header a[href*="/collections/collection-01"]').forEach((link) => {
      link.textContent = 'FORM 01';
      link.setAttribute('aria-label', 'FORM 01');
    });

    document.querySelectorAll('.announcement-bar__text').forEach((text) => {
      if (text.textContent.includes('COLLECTION 01')) {
        text.textContent = text.textContent.replace('COLLECTION 01', 'FORM 01');
      }
    });
  };

  const setup = () => {
    setupProduct();
    localize();
  };

  setup();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  }
  document.addEventListener('shopify:section:load', setup);
})();
